export const DARK_TEXT = '#262B41';
export const LIGHT_TEXT = '#FFFFFF';

export const isLight = (color) => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substr(0,2),16);
  const g = parseInt(hex.substr(2,2),16);
  const b = parseInt(hex.substr(4,2),16);
  return ((r*299)+(g*587)+(b*114))/1000 >= 200;
};

export const getFontColor = (bgHexColor) => {
  return isLight(bgHexColor) ? DARK_TEXT : LIGHT_TEXT;
};
